module.exports = __webpack_public_path__ + "assets/66.jpg?e1918d459c746a972c07d5f6f52ccd87";